<template>
  <div id="data-list-list-view" class="data-list-container">

    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <vx-card collapse="false" ref="filterCard" title="Filtros" class="user-list-filters mb-8" collapse-action
             refresh-content-action @refresh="resetFilters">
      <h5 class="mt-5 mb-2">Filtrar por fecha</h5>
      <div class="vx-row">
        <div class="vx-col md:w-1/2">
          <flat-pickr :config="configdateTimePicker"
                      v-model="filterData.startDate"
                      placeholder="Desde"
                      class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2">
          <flat-pickr :config="configdateTimePicker"
                      v-model="filterData.endDate"
                      placeholder="Hasta"
                      class="w-full"/>
        </div>
        <div class="vx-col mt-2">
          <vs-button @click="filter('dates')" class="mr-6 vs-align-right">Filtrar</vs-button>
        </div>
      </div>
    </vx-card>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="list">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
              currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ list.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : list.length }} de {{
              queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="store">Tienda</vs-th>
        <vs-th sort-key="address">Dirección</vs-th>
        <vs-th sort-key="pickupDate">Fecha de recojo</vs-th>
        <vs-th sort-key="dealer">Motorizado</vs-th>
        <vs-th sort-key="date">Cantidad de paquetes</vs-th>
        <vs-th sort-key="state">Acciones</vs-th>
      </template>

      <template slot-scope=" {data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.client.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.address }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.pickUpDate }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.dealer.displayName }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.itemsQuantity }}</p>
            </vs-td>

            <vs-td>
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current mr-4"
                            @click.stop="deleteItem(tr, indextr)"/>

              <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="editItem(tr)"/>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <!--Assign-->
    <detail :isSidebarActive="showAssignSidebar"
            :data="sidebarData"
            :dealers="dealers"
            @update="updateDataSideBar"
            @closeSidebar="showAssignSidebar = false"/>
    <!--End-->
  </div>
</template>

<script>
import moment from "moment"

import { db, Timestamp } from '@/firebase/firebaseConfig'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import Detail from "@/views/assignments/Detail.vue"

export default {
  components: {
    Detail,
    flatPickr
  },
  data() {
    return {
      selected: null,
      itemsPerPage: 100,
      isMounted: false,
      list: [],
      dealers: [],
      initProgress: false,
      showAssign: true,
      //Filters
      showFilter: false,
      filterData: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
      // Date
      configdateTimePicker: {
        dateFormat: 'Y-m-d'
      },
      // Data Sidebar
      showAssignSidebar: false,
      sidebarData: {},
      // Export
      fileName: '',
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      activePrompt: false,
      activePromptOrders: false
    }
  },
  async created() {
    await this.filter('today')
    await this.getDealers()
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.list.length
    }
  },
  methods: {
    /**
     * Filter
     * @param type
     * @returns {Promise<void>}
     */
    async filter(type) {
      try {
        this.initProgress = true
        this.list = []
        // Set start date
        let startDate = new Date()
        let endDate = new Date()
        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        // Set end date
        endDate.setHours(23)
        endDate.setMinutes(59)
        endDate.setSeconds(0)

        let startTimes = null
        let endTimes = null

        if (type === 'today') {
          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        }
        else if (type === 'tomorrow') {
          startDate.setDate((new Date()).getDate() + 1)
          endDate.setDate((new Date()).getDate() + 1)
          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        }
        else if (type === 'dates') {
          startDate = new Date(this.filterData.startDate + ' 00:00:00')
          startDate.setHours(0)
          startDate.setMinutes(0)
          startDate.setSeconds(0)
          console.log(startDate)
          endDate = new Date(this.filterData.endDate + ' 23:59:00')
          endDate.setHours(23)
          endDate.setMinutes(59)
          endDate.setSeconds(0)
          console.log(endDate)

          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        }

        console.log(startTimes)
        console.log(endTimes)

        const querySnapshot = await db.collection('assignments')
          .where('pickUpDate', '>=', startTimes)
          .where('pickUpDate', '<=', endTimes)
          .where('state', '==', true)
          .orderBy('pickUpDate', 'asc')
          .get()

        querySnapshot.forEach((doc) => {
          const obj = {
            ...doc.data(),
            pickUpDate: doc.data().pickUpDate.toDate(),
            createdAt: doc.data().createdAt.toDate()
          }

          obj.id = doc.id

          obj.pickUpDate = moment(obj.pickUpDate).format('YYYY-MM-DD')
          obj.createdAt = moment(obj.createdAt).format('YYYY-MM-DD HH:mm')

          this.list.push({
            ...obj
          })
        })

        console.log(this.list)
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Reset filters
     * @returns {Promise<void>}
     */
    async resetFilters() {
      try {
        this.initProgress = true
        await this.filter('today')

        this.$refs.filterCard.removeRefreshAnimation()
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Delete item
     */
    async deleteItem(object, index) {
      try {
        await db.collection('assignments').doc(object.id).update({
          state: false
        })
        this.list.splice(index ,1)

        this.$vs.notify({
          color: 'success',
          title: 'Asignaciones',
          text: 'Asignación eliminada correctamente.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Edit item
     */
    editItem (item) {
      this.sidebarData = item
      this.showAssignSidebar = true
    },
    /**
     * Get dealers
     */
    async getDealers() {
      try {
        const querySnap = await db.collection('users').where('role.value', '==', 'dealer').get()
        querySnap.forEach((doc) => {
          let obj = {
            ...doc.data()
          }
          obj.id = doc.id
          this.dealers.push(obj)
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Update data of sidebar
     * */
    updateDataSideBar (o) {
      const index = this.list.findIndex((d) => d.id === o.id)
      Object.assign(this.list[index], o)
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
